import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

type U3129HonorariumCoherenceIconProps = {
  message: string;
  className?: string;
};

/** Triangle ambre + infobulle native (BL-0688). */
const U3129HonorariumCoherenceIcon: React.FC<U3129HonorariumCoherenceIconProps> = ({ message, className = "" }) => {
  if (!message.trim()) return null;
  return (
    <span
      className={`inline-flex shrink-0 text-amber-500 ${className}`}
      title={message}
      aria-label={message}
      role="img"
    >
      <FaExclamationTriangle className="h-3.5 w-3.5" aria-hidden />
    </span>
  );
};

export default U3129HonorariumCoherenceIcon;
